'use client';

import { Typography } from '@/components/ui/Text';
import { PropsWithClassName } from '@/types/shared';
import clsx from 'clsx';
import { useCallback, useState } from 'react';
import { TBlogModuleFaqs } from '../../blog/blog.types';

import './BlogArticleModuleFAQs.scss';

const Chevron: React.FC<PropsWithClassName> = ({ className }) => (
  <svg
    className={className}
    width='16'
    height='16'
    viewBox='0 0 16 16'
    fill='none'
    xmlns='http://www.w3.org/2000/svg'
  >
    <path
      fillRule='evenodd'
      clipRule='evenodd'
      d='M3.64592 10.4571C3.59935 10.4106 3.56241 10.3554 3.5372 10.2947C3.512 10.2339 3.49902 10.1688 3.49902 10.1031C3.49902 10.0373 3.512 9.97217 3.5372 9.91143C3.56241 9.85068 3.59935 9.7955 3.64592 9.74906L7.99992 5.39606L12.3539 9.74906C12.4478 9.84295 12.5005 9.97028 12.5005 10.1031C12.5005 10.2358 12.4478 10.3632 12.3539 10.4571C12.26 10.5509 12.1327 10.6037 11.9999 10.6037C11.8671 10.6037 11.7398 10.5509 11.6459 10.4571L7.99992 6.81006L4.35392 10.4571C4.30747 10.5036 4.25229 10.5406 4.19155 10.5658C4.1308 10.591 4.06568 10.604 3.99992 10.604C3.93415 10.604 3.86903 10.591 3.80828 10.5658C3.74754 10.5406 3.69236 10.5036 3.64592 10.4571Z'
      fill='#292722'
    />
  </svg>
);

type Props = {
  module: TBlogModuleFaqs;
  mobile: boolean;
};

export const BlogArticleModuleFAQs: React.FC<Props> = ({
  module,
  mobile = false,
}) => {
  const [openedQuestions, setOpenedQuestions] = useState<string[]>([]);

  const handleClick = useCallback((questionId: string) => {
    setOpenedQuestions(previous => {
      if (previous.find(id => id === questionId)) {
        return previous.filter(id => id !== questionId);
      }

      return [...previous, questionId];
    });
  }, []);

  return (
    <div
      className={clsx('BlogArticleModuleFAQs', {
        'BlogArticleModuleFAQs--desktop': !mobile,
        'BlogArticleModuleFAQs--mobile': mobile,
      })}
    >
      {module.faqs.map(entry => (
        <div className='BlogArticleModuleFAQs__item' key={entry.item.id}>
          <div
            className='BlogArticleModuleFAQs__item-header'
            onClick={() => handleClick(entry.item.id)}
          >
            <Typography variant='body' bold>
              {entry.item.question}
            </Typography>

            <Chevron
              className={clsx('BlogArticleModuleFAQs__chevron', {
                'BlogArticleModuleFAQs__chevron--open': openedQuestions.find(
                  item => item === entry.item.id
                ),
              })}
            />
          </div>

          <div
            className={clsx('BlogArticleModuleFAQs__answer', {
              'BlogArticleModuleFAQs__answer--opened': openedQuestions.find(
                id => id === entry.item.id
              ),
            })}

            dangerouslySetInnerHTML={{ __html: entry.item.answer }}
          />

          <hr />
        </div>
      ))}
    </div>
  );
};
